<template>
  <component :is="layout"/>
</template>
<script>

import personaliza from "@/cuerpo/layouts/personaliza";
import auth from "@/cuerpo/layouts/auth";

import {obtenerToken} from "./servicios";


export default {
  components: {
    personaliza,
    auth
  },
  computed: {
    layout() {
      let aux = 'personaliza'
      try {
        if (this.$route.meta.middleware) {
          aux = 'auth'
        }
        // eslint-disable-next-line no-empty
      } catch (e) {}
      return aux
    }
  },

  methods: {
    obtenerToken: function () {
      obtenerToken.obtenerToken().then((response) => {
        localStorage.setItem('token', JSON.stringify(response.data));
      });
    },
  },

  mounted() {
    this.obtenerToken();
  },

}
</script>
<style scoped>

</style>

